import React, {Component} from "react";
import {View, Switch} from "react-native";
import {
    SwitchEdgesTypeAction,
    InitEdgesAction
} from "../../store/actions";

import nodesDataList from "../../data/nodeData.json";
import edgesData from '../../data/edgesTotal.json';
import {Division} from "../../data/Division";


import {generateNodesData, getBezierEdgesParseByEdgeList} from '../../utils';
import {bezierEdge, scale} from "../../store/model";


interface props {
    state: any
    dimension: scale
    initEdges: (newState: Array<bezierEdge>) => InitEdgesAction;
    switchEdgesType: () => SwitchEdgesTypeAction;
}

class SwitchType extends Component<props> {


    render() {
        const {height, width} = this.props.dimension;
        const {initEdges, switchEdgesType} = this.props;
        const scale = width / 3840;

        const toggleSwitch = () => {
            switchEdgesType()
            let nodesData = generateNodesData(Division, nodesDataList, height * 0.03, height * 0.85, this.props.state.EdgesData.EdgesTension / 100, scale)
            let edgesParse = getBezierEdgesParseByEdgeList(nodesData, Array.from(new Set(edgesData)), !this.props.state.EdgesData.EdgesType, {
                height,
                width
            }, this.props.state.EdgesData.EdgesTension / 100);
            initEdges(edgesParse);
        };
        return (
            <>
                <span className='NunitoText'
                     style={{
                         color: "#AAA",
                         float: "left",
                         top: '100%'
                     }}>{"type1 "}</span>
                <span style={{float: "left", paddingLeft: 5 * scale,}}>
                    <View style={
                        {
                            flex: 1,
                        }
                    }>
                        <Switch
                            trackColor={{false: "#f5dd4b", true: "#f5dd4b"}}
                            thumbColor="#444"
                            ios_backgroundColor="#3e3e3e"
                            onValueChange={toggleSwitch}
                            value={this.props.state.EdgesData.EdgesType}
                        />
                    </View>
                </span>
                <span className='NunitoText'
                     style={{
                         color: "#AAA",
                         float: "left",
                         paddingLeft: 5 * scale,
                     }}>type2
                </span>
            </>
        )
    }

}


export default SwitchType;